<template>
  <b-row v-if="Number(QueryStringValue.IsApproval) == 1">

    <ApprovalConfirmation v-if="ApprovalListchange.length != 0 &&
      ApprovalListchange.some(item => item['IsApproved'] == 0)" :approvaldata="ApprovalListchange"
      :approvaldetails="approvaldetails" @triggerDetails="getApprovaldata()" @Approve="IsSubmitChk"
      :SuccessfullPopUp="SuccessfullPopUp" />
    <ApprovalStatus v-if="ApprovalList.length != 0" :ApprovalgetList="ApprovalList"
      :approvaldetails="approvaldetails" />
  </b-row>

  <!-- {{ storeForm }} -->

  <div class="overall-bg pt-0">
    <b-container class="tab-view">

      <b-form @submit.prevent="IsSubmitChk('')">
        <b-row class="stepperdiv">
          <b-col lg="6" md="6" sm="6" cols="2">
            <BackToMasters :goback="$router.back" v-if="Number(QueryStringValue.IsApproval) !== 1"></BackToMasters>
            <Headerlayout :headertext="$t('Request.title')" :contenttext="$t('Request.contents')"></Headerlayout>
          </b-col>
          <b-col lg="6" md="6" sm="6" cols="2">
            <div class="d-flex align-items-center justify-content-end">
              <Footer type="Submit" :goback="$router.back" v-if="Number(QueryStringValue.IsApproval) != 1"
                :loading="SaveLoader" :label="label" />
              <Button label="Print" severity="success" icon="pi pi-print" class="printbtn ms-2" @click="Print"
                v-if="Number(QueryStringValue.IsApproval) == 1" />
            </div>
          </b-col>
        </b-row>
        <b-row class="form-white-bg">

          <RequestId :store-details="storeForm" v-model="requestData" :EntityId="Number(QueryStringValue.EntityId)"
            :CategoryHide="false" />
          <b-col lg="6" md="4" sm="6" cols="12" class="d-flex">
            <div class="field">
              <label>{{ $t("Request.uploadquotation") }}</label>
              <input type="file" :multiple="true" id="actual-btn" @change="handleChangedocument" ref="fileInput"
                style="display: none;" />
              <label id="custom-btn" for="actual-btn" class="flbtn">
                <i class="pi pi-upload" style="color: slateblue"></i>
                Choose File</label>
            </div>
          </b-col>
          <b-row>
            <b-col lg="3" md="4" sm="6" cols="12" class="d-flex" v-for="item in uploadedTableList">
              <div class="fileuploadcard my-2" :title="item.fileName">
                <div>
                  <p class="filenametxt">{{ item.fileName }}</p>
                  <div class="blue-txt" id="file-name" @click="fileviewer(item.fullPath)">
                    view </div>
                </div>
                <DeleteIcon @click="fileuploadDelete(item)" />
              </div>
            </b-col>
          </b-row>
          <div class="transactiontabs">
            <TabView class="tabview-custom" ref="tabview4">
              <TabPanel :class="ItemTab">
                <template #header>
                  <i class="pi pi-align-left pe-3"></i>
                  <span>{{ $t('invtabs.items') }}</span>
                </template>
                <div>
                  <b-row v-if="Number(QueryStringValue.IsApproval) != 1 && IsApprovedValue" class="pt-3">
                    <b-col lg="4" md="4" sm="6" v-if="ObjCamp.IsCamp == false">
                      <div class="field">
                        <CustomMultiSelect placeholder="Select Frequest Requests" v-model="RequestOPT.FRequestIds"
                          :items="RequestOPT.FRequestOption" ref="multiRef" :label="$t('Request.recentrequest')"
                          @update:modelValue="FreqRequestIDOnChange" />
                      </div>
                    </b-col>
                    <b-col lg="4" md="4" sm="6" v-if="ObjCamp.IsCamp == false">
                      <div class="field">
                        <CustomMultiSelect placeholder="Select Request Id" v-model="RequestOPT.RequestIds"
                          :label="$t('Request.inboundrequest')" :items="RequestOPT.RequestOption" ref="multiRef"
                          @update:modelValue="RequestIDOnChange" />
                      </div>
                    </b-col>

                    <b-col lg="4" md="4" sm="6" v-if="ObjCamp.IsCamp == true">
                      <div class="field">
                        <CustomDropDown v-model="ObjCamp.SelectedCampName" :items="ObjCamp.CampOption"
                          @update:modelValue="CampOnChange" id="CampName" name="Camp name"
                          :label="$t('Request.CampName')" :rules="{ required: true }" :required-icon="true"
                          :disabled="Number(QueryStringValue.IsDraft) == 0 ? true : false" />
                      </div>
                    </b-col>

                    <b-col lg="4" md="4" sm="6">
                      <div class="field">
                        <CustomMultiSelect placeholder="Select IndentTemplate Id" v-model="RequestOPT.FIndentIds"
                          :label="$t('Request.indenttemplate')" :items="RequestOPT.FIndentOption" ref="multiRef"
                          @update:modelValue="IndentIDOnChange" />
                      </div>
                    </b-col>
                  </b-row>
                  <b-row v-if="ObjCamp.IsCamp && ObjCamp.CampDetailCard">
                    <p class="fn14 fw500">Camp Details</p>
                    <b-col lg="6" md="6" class="campdetailscard">
                      <b-row>
                        <b-col lg="8" md="8" class="d-flex align-items-center gap-2">
                          <p class="light-txt">Institute name:</p>
                          <p class="fn14 fw500">{{ ObjCamp.InstituteName }}</p>
                        </b-col>
                        <b-col lg="4" md="4" class="d-flex align-items-center gap-2">
                          <p class="light-txt">Camp date:</p>
                          <p class="fn14 fw500">{{ ObjCamp.FormattedCampDate }}</p>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col lg="8" md="8" class="d-flex align-items-center gap-2 py-2">
                          <p class="light-txt">Camp type:</p>
                          <p class="fn14 fw500">{{ ObjCamp.CampType }}</p>
                        </b-col>
                        <b-col lg="4" md="4" class="d-flex align-items-center gap-2">
                          <p class="light-txt">Expected IP:</p>
                          <p class="fn14 fw500">{{ ObjCamp.ExpectedIP }}</p>
                        </b-col>

                      </b-row>
                      <b-row>
                        <b-col lg="8" md="8" class="d-flex align-items-center gap-2">
                          <p class="light-txt">Camp name:</p>
                          <p class="fn14 fw500">{{ ObjCamp.CampName }}</p>
                        </b-col>
                        <b-col lg="4" md="4" class="d-flex align-items-center gap-2">
                          <p class="light-txt">Expected OP:</p>
                          <p class="fn14 fw500">{{ ObjCamp.ExpectedOP }}</p>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-row v-if="IsApprovedValue">
                    <b-col class="d-flex flex-row-reverse pb-2">
                      <p class="add-items d-flex d-flex-row-reverse" v-b-toggle.collapse-3>
                        + Add New
                      </p>
                    </b-col>
                  </b-row>
                  <b-row v-if="IsApprovedValue">
                    <b-col>
                      <b-collapse id="collapse-3" :class="displayClass">
                        <!-- {{ commonItemProps }} -->

                        <Item @additemclick="AddItems" v-model:data-items="dataItems" :show-fields="showFields"
                          :addItemData="items" :commonItemProps="commonItemProps" LasTTransactionDocType="1" />

                      </b-collapse>
                    </b-col>
                  </b-row>

                  <Tableview :rowHover="true" filterDisplay="menu" :loading="loading" responsiveLayout="scroll"
                    :columns="headers" v-model:value="items" :row-click="TblIndex" :seriaNlumber='true'>

                    <template v-slot:Brandmodelsize="{ data }">

                      <p v-if="data.BrandName == '' && data.ModelNumberName == '' && data.SizeName == ''">
                        {{ "-" }}
                      </p>
                      <p v-else>
                        {{ data.BrandName != '' ? data.BrandName : "-" }} /
                        {{ data.ModelNumberName != '' ? data.ModelNumberName : "-" }} /
                        {{ data.SizeName != '' ? data.SizeName : "-" }}
                      </P>
                    </template>

                    <template v-slot:quantity="{ data, rowIndex }">

                      <div class="label-d-none tablefield mb-0">
                        <InputText type="text" placeholder="" clearable
                          :name="`'Qty'${rowIndex}` + '_' + Math.random().toString(36).substring(2, 15)"
                          autocomplete="new-password" :style="{ 'background-image': 'none !important' }"
                          :id="`'Qty'${rowIndex}`" @keyup="ItemQtyOnChange(data)" label="" v-model="data.ItemQuantity"
                          :rules="{ required: false, numeric: true, nonzeroable: true }" :requiredIcon="false"
                          :disabled="false" />
                      </div>
                    </template>

                    <template v-slot:StockInHand="{ data }">
                      {{
                        data.StockInHand - (data.PickedQty + data.InTransist)
                      }}
                    </template>

                    <template v-slot:action="{ data, rowIndex }">
                      <span class="d-flex align-items-center">
                        <!-- <EditIcon @click="IsItemEdit(data)" /> -->
                        <!-- {{ rowIndex }} -->
                        <DeleteIcon @click="ItemDeleteConfirm($event, data, rowIndex)" />

                      </span>
                    </template>
                  </Tableview>

                  <b-row v-if="Number(QueryStringValue.IsApproval) == 1">
                    <b-col offset-lg="3" class="d-flex px-0 justify-content-end">
                      <div class="totaldiv1">
                        <p class="component-heading">{{ RequestCalcDetails.ItemCount }}</p>

                        <p class="light-txt">Items Part of this request</p>
                      </div>
                      <div class="totaldiv2">
                        <p class="component-heading"><span class="pe-1">&#8377</span>{{ RequestCalcDetails.TotalAmount
                          }}
                        </p>
                        <p class="light-txt mt-3">{{ $t('grn.value') }}</p>
                      </div>
                    </b-col>
                  </b-row>

                </div>
              </TabPanel>
              <TabPanel>
                <template #header>
                  <i class="pi pi-shopping-bag pe-3"></i>
                  <span>{{ $t('invtabs.itembelowreorderlevel') }}</span>
                </template>
                <p>
                  <AddItemsVue @AddSingleClick="AddSingleConfirmation('Single')"
                    @SelectAll="AddAllConfirmation('All')" />
                  <Tableview :rowHover="true" filterDisplay="menu" :loading="loading" responsiveLayout="scroll"
                    :columns="ReOrderheaders" v-model:value="ReOrderData" v-model:selection="selectedProduct"
                    :selectionMode="true">
                    <!-- <template v-slot:check="{ data }">
                  <span>
                    <Checkbox :value="data" v-model="selectedProduct"></Checkbox>
                  </span>
                </template> -->
                    <!-- <template v-slot:action="{ data }">
                    <span>
                      <DeleteIcon @click="IsReOrderDelete(data)" />
                    </span>
                  </template> -->
                    <template v-slot:Brandmodelsize="{ data }">
                      <p v-if="data.BrandName == null && data.ModelNumberName == null && data.SizeName == null">
                        {{ "-" }}
                      </p>
                      <p v-else>
                        {{ data.BrandName != null ? data.BrandName : "-" }} /
                        {{ data.ModelNumberName != null ? data.ModelNumberName : "-" }} /
                        {{ data.SizeName != null ? data.SizeName : "-" }}
                      </P>
                    </template>

                    <template v-slot:action="{ data }">
                      <span>
                        <!-- <EditIcon @click="IsItemEdit(data)" /> -->
                        <DeleteIcon @click="IsReOrderDelete(data)" />
                      </span>
                    </template>
                  </Tableview>
                </p>
              </TabPanel>
            </TabView>
          </div>
        </b-row>
      </b-form>
    </b-container>
  </div>
  <RequestPopupVue v-model="storeForm" :StoreDetailsData="storeForm" @storeUpdate="storeUpdate" v-if="display" />
  <Toast />
  <ConfirmPopup />

  <CreateSuccessully :visible="popup.successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="popup.updatepop" @ok="closetrigger()" />
  <AddItemConfirmation :Editmodel="AddItemmodel" @yes="CopyReorderData(confirmval)" @no="AddItemmodel = false"
    :content="msgcontent" />
  <WarningMessage :visible="wariningPopup" :content="warningmsgcontent.warningcontent" @ok="ClosewariningPopup()" />
  <CrystalReportPrintPopUp :ShowAndHide="CrystalReportPopup" :ParameterValues="ParameterValues"
    :PrintType="PrintType" />

  <CrystalReportPrintPopUp1 :ShowAndHide="CrystalReportPopup1" :ParameterValues="ParameterValues1"
    :PrintType="PrintType1" @closepopup="hidepopup" />

  <div class="center" v-if="loading">
    <Loader :loading="loading" />
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  computed,
  reactive,
  onMounted,
  watch,
  onUnmounted
} from "vue";
import BackToMasters from "../../../../../../components/FormComponents/BacktoMaster.vue";
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import Badge from "primevue/badge";
import AddItemsVue from "../../../../../../modules/Inventory/components/Transaction/AddItems.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import Tableview from "../../../../../../components/FormComponents/NormalTable.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Item from "../../../../../../modules/Inventory/components/Transaction/Item.vue";
import { useRoute, useRouter } from "vue-router";
import Footer from "../../../../../../components/FormComponents/Footer.vue";
import cancel from "../../../../../../components/GeneralButtons/CancelButtton.vue";
import RequestId from "../../../../../../modules/Inventory/components/Transaction/stockwithoutaffect/RequestId.vue";
import commonService from "../../../../Service/WithoutStockAffectService";
import IndentTemplateService from "../../../../../../modules/Inventory/Service/IndentTemplateService";
import CreateSuccessully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import AddItemConfirmation from "../../../../../../components/FormComponents/AddItemsConfirmation.vue";
import WarningMessage from "../../../../../../components/FormComponents/WarningMessage.vue";
import RequestPopupVue from "../../../../../../modules/Inventory/components/Transaction/stockwithoutaffect/RequestPopup.vue";
import CrystalReportPrintPopUp from "../../../../../../modules/Inventory/components/Print/CrystalReportPrint.vue";
import CustomMultiSelect from "../../../../../../components/FormComponents/MultiSelectDropdown.vue";
import { value } from "dom7";
import { useToast } from "primevue/usetoast";
import { useConfirm } from "primevue/useconfirm";

import moment from "moment";
import ApprovalConfirmation from "../../../../../../components/FormComponents/ApprovalConfirmation.vue";
import ApprovalStatus from "../../../../../../components/FormComponents/ApprovalStatus.vue";
import PoApprovalService from "../../../../../../modules/Inventory/Service/PoApprovalService";
import TextField from "../../../../../../components/FormComponents/TextInput.vue";
import { useForm } from "vee-validate";
import { setupHistoryManagement } from "../../../../../../modules/Inventory/Service/HistoryManage";
import { useI18n } from 'vue-i18n';
import StockWOFileUploadServices from "../../../../../../modules/Inventory/Service/StockWOFileUploadService";
import common from "../../../../../../modules/Inventory/Service/CommonService";
import CustomDropDown from "../../../../../../components/FormComponents/Dropdown.vue";
import CampService from "../../../../../../modules/Inventory/Service/CampService";
import CrystalReportPrintPopUp1 from "../../../../../../modules/Inventory/components/Print/CrystalReportPrint.vue";


export default defineComponent({
  components: {
    Loader,
    Badge,
    AddItemsVue,
    Item,
    Tableview,
    Footer,
    cancel,
    BackToMasters,
    Headerlayout,
    RequestId,
    CreateSuccessully,
    UpdatedSuccessfully,
    AddItemConfirmation,
    WarningMessage,
    RequestPopupVue,
    CrystalReportPrintPopUp,
    CustomMultiSelect,
    ApprovalConfirmation,
    ApprovalStatus,
    TextField,
    CustomDropDown,
    CrystalReportPrintPopUp1
  },
  props: {
    showone: {
      type: String,
      default: "",
    },
    Operations: {
      type: Object,
      default: () => ({}),
    },
    ApprovalObj: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {

    const routes = useRoute();
    const router = useRouter();
    const { t } = useI18n();

    let session: any = localStorage.getItem("UsersData");

    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);

    const toast = useToast();
    const confirm = useConfirm();

    const items: any = ref([]);
    const dupitems: any = ref([]);

    let currentDate = new Date().toISOString().slice(0, 10);

    let fullPath = ref();
    let uploadedTableList: any = ref([])
    let DeletedFileUpload: any = []
    const StockWOFileUpload = ref([]);
    const label = ref(t("btn.save"));

    const ReOrderData: any = ref([]);
    let msgcontent = ref({ contentvalue: "" });
    let warningmsgcontent = ref({ warningcontent: "" });
    const confirmval = ref();
    let loading = ref(false);
    let SaveLoader = ref(false);
    let showitemfield = ref(false);
    const display = ref(true);
    const displayClass = ref("show");
    const ItemTab = ref("");
    let diffArray: any = [];
    let arr: any = [];
    const dataItems = ref({});
    const CrystalReportPopup = ref(false);
    let ApprovalList = ref([]);
    let ApprovalListchange = ref([]);

    watch(
      () => t("btn.save"),
      (newValue) => {
        label.value = newValue;
      }
    );

    let approvaldetails: any = ref({
      HeaderName: "Request",
      ContentName: "Request",
      ApprovalCode: 0,
      ApprovalDate: "",
      ApprovalPrice: 0,
      CreatedAt: "",
    });

    let SuccessfullPopUp = ref({
      accept: ref(false),
      decline: ref(false),
    });

    const commonItemProps = ref({
      storeId: 0,
      type: 0,
      tostoreId: 0,
      StoreBrMapId: 0,
      FromStoreBrMapId: 0,
      ToStoreBrMapId: 0,
      FromStoreBranchId: 0,
      ToStoreBranchId: 0,
      UOMFlag: true
    });

    const { handleSubmit, errors, resetForm, resetField } = useForm();

    const AddItemmodel = ref(false);
    const wariningPopup = ref(false);

    let IsApprovedValue = ref(true);
    let QueryStringValue = ref(routes.query);
    commonItemProps.value.storeId = Number(QueryStringValue.value.StoreId) ?? 0;
    let ObjCamp: any = ref(
      {
        CampDetailCard: false,
        IsCamp: QueryStringValue.value.IsCamp === 'true' ? true : false,
        CampOption: [],
        CampId: ref(),
        InstituteName: "",
        CampName: "",
        SelectedCampName: "",
        CampType: "",
        CampDate: "",
        FormattedCampDate: "",
        ExpectedIP: "",
        ExpectedOP: "",
      }
    )

    watch(
      () => [props.Operations, props.ApprovalObj],
      ([newOperations, newApprovalObj]) => {
        debugger;
        if (newOperations.Id) {
          QueryStringValue.value = newOperations;
        }

        if (newApprovalObj.Status) {
          UpdateApprovalStatus(newApprovalObj.Status);
        }
      },
      { immediate: true, deep: true }
    );

    let showFields = {
      Category: {
        show: true,
        require: false,
      },
      Name: {
        show: true,
        require: true,
      },

      PackSize: {
        show: false,
        require: false,
      },

      Qty: {
        show: true,
        require: true,
      },
      UnitRate: {
        show: false,
        require: true,
      },
      Brand: {
        show: true,
        require: false,
      },
      ModelNumber: {
        show: true,
        require: false,
      },
      Size: {
        show: true,
        require: false,
      },
      UOM: {
        show: true,
        require: true,
      }
    };

    const storeForm = ref({
      FromStore: 0,
      FromStoreName: "",
      ToStore: 0,
      ToStoreName: "",
      FromStoreCode: "",
      ToStoreCode: "",
    });

    storeForm.value.FromStore = Number(QueryStringValue.value.StoreId);

    const fieldData = reactive({
      DocNo: "",
      Remarks: "",
    });

    const RequestCalcDetails = ref({
      GrossAmount: 0.00,
      ItemCount: 0,
      TotalAmount: 0.00
    })

    const requestForm = ref({
      DocType: "1",
      DocNo: "",
      DocDate: currentDate,
      StoreId: 0,
      FromStore: 0,
      ToStore: 0,
      HospitalId: 0,
      BranchId: 0,
      CreatedAt: currentDate,
      Remarks: "",
      Id: 0,
      ModifiedAt: "",
      ModifiedBy: 0,
      CreatedBy: 0,
      EntityId: 0,
      EntityOperationId: 0,
      DeptRoleId: 0,
      StoreBrMapId: 0,
      FromStoreBranchId: 0,
      FromStoreBrMapId: 0,
      ToStoreBranchId: 0,
      ToStoreBrMapId: 0,
      Status: "0",
      ClosedReason: "",
      CancelReason: "",
      Remarkscheck: 0,
      IsDraft: 0,
      StockWODetailList: [],

      IsCamp: 0,
      CampId: 0,
      InstituteName: "",
      CampName: "",
      CampType: "",
      CampDate: "",
      ExpectedIP: "",
      ExpectedOP: ""
    });

    const popup = ref({
      successpop: false,
      updatepop: false,
    });

    const requestData = ref({
      DocNo: "",
      Remarks: "",
      Category: 1,
      Remarkscheck: ref()
    });

    const StoreDetailsData = ref({
      StoreId: 0,
    });
    const RequestOPT = ref({
      RequestIds: ref(),
      RequestOption: [],
      FRequestIds: ref(),
      FRequestOption: [],
      FIndentIds: ref(),
      FIndentOption: [],
    });

    const TblIndex = ref(0);
    const selectedProduct: any = ref([]);
    const ColumnVisible = ref(false);
    ColumnVisible.value = Number(QueryStringValue.value.status) != 1 ? true : false;
    let RequestId = "";
    let SavingArray: any = ref([]);
    let FRequestId = "";
    let FSavingArray: any = ref([]);


    let rolesData;
    let DeptRoleMapId

    let SessionRolesData = localStorage.getItem("RolesData");
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
      DeptRoleMapId = Number(rolesData.DeptRoleMapId);
    }

    /* variable declaration*/
    const headers = computed(() =>
      [
        {
          header: t('storetabdetails.requestcreationtable.Code'),
          field: "ItemProductId",
          class: "smallwidth"
        },

        {
          header: t('storetabdetails.requestcreationtable.Name'),
          field: "Itemname1",
          bodyclass: "boldclass text_overflow2",
          class: "mediumwidth",
        },
        {
          header: t('storetabdetails.requestcreationtable.Brand/Model/Size'),
          field: "",
          slot: "Brandmodelsize",
          fieldDisplay: "false",
          // bodyclass: "right_td",
        },
        {
          header: t('storetabdetails.requestcreationtable.AvlQty'),
          field: "StockInHand",
          slot: 'StockInHand',
          fieldDisplay: "false",
          filterTemplate: "MultiSelect",
          ShowMactchMode: false,
          bodyclass: "right_td",
          class: "smallwidth",
          hide: ColumnVisible.value,
        },
        {
          header: t('storetabdetails.requestcreationtable.PickedQty'),
          field: "PickedQty",
          filterTemplate: "MultiSelect",
          ShowMactchMode: false,
          bodyclass: "right_td",
          class: "smallwidth",
          hide: ColumnVisible.value,
        },
        {
          header: t('storetabdetails.requestcreationtable.InTransist'),
          field: "InTransist",
          filterTemplate: "MultiSelect",
          ShowMactchMode: false,
          bodyclass: "right_td",
          class: "smallwidth",
          hide: ColumnVisible.value,
        },
        {
          header: t('storetabdetails.requestcreationtable.Reorderlevel'),
          field: "ReOrderLevel",
          bodyclass: "right_td",
          class: "smallwidth"
        },
        {
          header: t('storetabdetails.requestcreationtable.UOM'),
          field: "UOMName",
          bodyclass: "",
          class: "smallwidth"
        },
        {
          header: t('storetabdetails.requestcreationtable.Qty'),
          field: "",
          slot: "quantity",
          bodyclass: "right_td",
          class: "smallwidth",
          fieldDisplay: "false",
        },
        {
          header: t('storetabdetails.requestcreationtable.UnitRate'),
          field: "UnitRate",
          bodyclass: "right_td",
          class: Number(QueryStringValue.value.IsApproval) == 1 ? "smallwidth" : "d-none",
        },
        {
          header: t('storetabdetails.requestcreationtable.Rate'),
          field: "Rate",
          bodyclass: "right_td",
          class: Number(QueryStringValue.value.IsApproval) == 1 ? "smallwidth" : "d-none",
        },
        {
          field: "action",
          header: "",
          slot: "action",
          frozencolumn: true,
          sortable: false,
          class: IsApprovedValue.value == false ? "d-none" : "columnfreeze",
          fieldDisplay: "false",
        },
      ]
    );

    //ReOrder Level Table
    const ReOrderheaders = [
      {
        header: t('storetabdetails.requestcreationreordertable.Id'),
        field: "ItemCode",
        class: "smallwidth",
      },
      {
        header: t('storetabdetails.requestcreationreordertable.Code'),
        field: "ItemProductId",
        class: "smallwidth newcolumnfreezeleft1",
      },
      {
        header: t('storetabdetails.requestcreationreordertable.Name'),
        field: "Itemname1",
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth newcolumnfreezeleft2",
      },
      {
        header: t('storetabdetails.requestcreationreordertable.Brand/Model/Size'),
        field: "",
        slot: "Brandmodelsize",
        fieldDisplay: "false",
        class: "newcolumnfreezeleft3"
      },
      {
        header: t('storetabdetails.requestcreationreordertable.AvlQty'),
        field: "StockInHand",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.requestcreationreordertable.Reorderlevel'),
        field: "ReOrderLevel",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.requestcreationreordertable.Qty'),
        field: "ItemQuantity",
        bodyclass: "right_td",
        class: "smallwidth",
        slot: "quantity"
      },

      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "last-column-position columnfreeze",
        fieldDisplay: "false",
      },
    ];

    onMounted(() => {
      ReadyFunction()
    });

    async function ReadyFunction() {
      debugger;

      if (ObjCamp.value.IsCamp == true) {
        await LoadCamp()
      }
      else {
        await LoadFrequestRequestID();
        await LoadRequestID();
      }
      await LoadIndentID();
      await LoadReOrderLevel();

      if (QueryStringValue.value.Id) {
        display.value = false;
        IsEdit();
        if (Number(QueryStringValue.value.IsApproval) !== 1) {
          getApprovaldata()
        }
      }
    }

    /*Method Defintion*/
    function storeUpdate(data) {
      debugger;
      commonItemProps.value.storeId = data.FromStore;
      commonItemProps.value.tostoreId = data.ToStoreBrMapId['StoreId']

      commonItemProps.value.StoreBrMapId = data.StoreBrMapId;
      commonItemProps.value.FromStoreBrMapId = data.FromStoreBrMapId;
      commonItemProps.value.ToStoreBrMapId = data.ToStoreBrMapId['StoreBranchMapId']

      commonItemProps.value.FromStoreBranchId = data.FromStoreBranchId;
      commonItemProps.value.ToStoreBranchId = data.ToStoreBranchId;
    }

    //Item Edit
    function IsItemEdit(data) {
      debugger;
      dataItems.value = {};
      dataItems.value = data;
      dataItems.value["IsEdit"] = 1;
      dataItems.value["IsRequest"] = 1;
      displayClass.value = "show";
      scrollToTop()
    }

    //Item Delete

    const ItemDeleteConfirm = (event, data, indexToRemove) => {
      confirm.require({
        target: event.currentTarget,
        message: 'Do you want to delete this record?',
        icon: 'pi pi-info-circle',
        rejectClass: 'p-button-secondary p-button-outlined p-button-sm',
        acceptClass: 'p-button-danger p-button-sm',
        rejectLabel: 'Cancel',
        acceptLabel: 'Delete',
        accept: () => {
          IsItemDelete(data, indexToRemove)
        },
        reject: () => {
          toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
        }
      });
    };

    function IsItemDelete(data, indexToRemove) {
      if (items.value.length > 1) {
        if (indexToRemove > -1 && indexToRemove < items.value.length) {
          items.value.splice(indexToRemove, 1);
          IsDelete(data)
        }
      }
      else {
        toast.add({
          severity: "warn",
          summary: "Cannot able to delete the last item",
          detail: "",
          life: 3000,
        });
        return;
      }
    }

    const IsDelete = async (data) => {
      try {
        debugger;

        let result: any;
        result = await commonService.deleteStockWoDetails(data.StockDetailsId);

        let message = result["ErrorInfo"].ErrorCode;
        if (message == null) {
          toast.add({ severity: 'info', summary: 'Confirmed', detail: 'Record deleted', life: 3000 });
          return;
        }
        else {
          toast.add({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
          return;
        }

      } catch (error) {
        alert(error);
      }
    };

    async function IsSubmitChk(Values) {
      debugger
      if (items.value.length == 0) {
        toast.add({
          severity: "warn",
          summary: "Please Add the Item",
          detail: "",
          life: 3000,
        });
        return false;
      }
      if (Number(QueryStringValue.value.IsApproval) == 1) {
        Approve(Values);
      }
      else {
        IsSubmit()
      }
    }

    // watch(items,() => {
    //   debugger;
    //   if (items.value.length == 1){
    //     alert('ui')
    //     // if (items.value.length == 1) {

    //     // }
    //   }

    //}, { deep: true });

    const IsSubmit = handleSubmit(async (values) => {
      debugger;
      SaveLoader.value = true
      var FileUploadArray: any = [];
      console.log(requestData.value);
      if (items.value.length > 0) {
        Object.keys(requestData.value).forEach((key) => {
          if (requestData.value[key])
            requestForm.value[key] = requestData.value[key];
        });
        Object.keys(requestForm.value).forEach((key) => {
          if (storeForm.value[key])
            requestForm.value[key] = storeForm.value[key];
        });
        console.log(requestForm.value);

        requestForm.value.CreatedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        requestForm.value.ModifiedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        requestForm.value.BranchId = Number(QueryStringValue.value.BranchId ?? 0);
        requestForm.value.HospitalId = HospitalId;
        requestForm.value.ModifiedBy = UserId;
        requestForm.value.CreatedBy = UserId;
        requestForm.value.EntityId = Number(QueryStringValue.value.EntityId);
        requestForm.value.DocDate = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        requestForm.value.StoreId = requestForm.value.FromStore;
        requestForm.value.EntityOperationId = Number(QueryStringValue.value.OperationId ?? 0);
        requestForm.value.DeptRoleId = rolesData.DeptRoleMapId;
        requestForm.value.FromStoreBranchId = commonItemProps.value.FromStoreBranchId;
        requestForm.value.FromStoreBrMapId = commonItemProps.value.FromStoreBrMapId;
        requestForm.value.ToStoreBranchId = commonItemProps.value.ToStoreBranchId;
        requestForm.value.ToStoreBrMapId = commonItemProps.value.ToStoreBrMapId;
        requestForm.value.ToStore = commonItemProps.value.tostoreId;
        requestForm.value.StoreBrMapId = commonItemProps.value.StoreBrMapId;
        requestForm.value.Remarkscheck = requestData.value.Remarkscheck == true ? 1 : 0;
        requestForm.value.IsDraft = 0;

        requestForm.value.IsCamp = ObjCamp.value.IsCamp || false;
        requestForm.value.CampId = 0;
        requestForm.value.InstituteName = ObjCamp.value.InstituteName || "";
        requestForm.value.CampName = ObjCamp.value.CampName || "";
        requestForm.value.CampType = ObjCamp.value.CampType || "";
        requestForm.value.CampDate = ObjCamp.value.CampDate || "";
        requestForm.value.ExpectedIP = ObjCamp.value.ExpectedIP || "";
        requestForm.value.ExpectedOP = ObjCamp.value.ExpectedOP || "";

        //let result: any;
        let msg: String = "";
        let id: any = 0;
        if (QueryStringValue.value.Id) {
          requestForm.value.Id = Number(QueryStringValue.value.Id);
        }
        debugger;
        for (let i = 0; i < items.value.length; i++) {
          let obj = {};
          (obj["ItemId"] = items.value[i]["ItemId"]),
            (obj["Qty"] = items.value[i]["ItemQuantity"]),
            (obj["RefId"] = id),
            (obj["PackSizeId"] = items.value[i]["PackSizeId"]),
            (obj["HSNId"] = items.value[i]["HSNId"]),
            (obj["UnitRate"] = items.value[i]["UnitRate"]),
            (obj["Rate"] = items.value[i]["Rate"]),
            (obj["CreatedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
            (obj["ModifiedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
            (obj["CreatedBy"] = UserId),
            (obj["ModifiedBy"] = UserId),
            (obj["Id"] = items.value[i]["StockDetailsId"]),
            (obj["AutoRequestId"] = items.value[i]?.["AutoRequestId"] || 0);
          (obj["Brand"] =
            items.value[i]["Brand"] == null ? 0 : items.value[i]["Brand"]),
            (obj["ModelNumber"] =
              items.value[i]["ModelNumber"] == null
                ? 0
                : items.value[i]["ModelNumber"]),
            (obj["Size"] =
              items.value[i]["Size"] == null ? 0 : items.value[i]["Size"]);
          (obj["FromApproval"] = Number(QueryStringValue.value.IsApproval) || 0);
          (obj["UOM"] = items.value[i]["UOM"])
          arr[i] = obj;
        }
        requestForm.value.StockWODetailList = arr
        let result = await commonService.createStockWODraft(requestForm.value);
        id = result["result"][0].Id
        requestForm.value.Id = id
        for (let i = 0; i < requestForm.value.StockWODetailList.length; i++) {
          const ResultList = result["result"][0]
          items.value[i].Id = ResultList.StockWODetailList[i]['Id'];
          items.value[i].StockDetailsId = ResultList.StockWODetailList[i]['Id'];
        }
        if (uploadedTableList.value.length != 0) {
          for (let i = 0; i < uploadedTableList.value.length; i++) {
            let Fileobj = {};
            (Fileobj["Id"] = uploadedTableList.value[i].Id),
              (Fileobj["DocType"] = "1"),
              (Fileobj["RefId"] = requestForm.value.Id),
              (Fileobj["FileName"] = uploadedTableList.value[i].fileName),
              (Fileobj["CreatedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
              (Fileobj["CreatedBy"] = UserId),
              (Fileobj["ModifiedBy"] = 0),
              (Fileobj["EntityId"] = Number(QueryStringValue.value.EntityId)),
              (Fileobj["IsApproved"] = 0),
              FileUploadArray.push(Fileobj)
          }
          StockWOFileUpload.value = FileUploadArray
          let FileUploadResult = await StockWOFileUploadServices.insertStockWOFile(StockWOFileUpload.value);
        }
        if (DeletedFileUpload.length > 0) {
          debugger
          let result = await StockWOFileUploadServices.DeleteList(DeletedFileUpload.join(','));
        }
        let msgMapping = result["ErrorInfo"].ErrorCode;
        if (msgMapping == null && Number(QueryStringValue.value.IsApproval) != 1) {
          if (QueryStringValue.value.Id) {
            SaveLoader.value = false
            popup.value.updatepop = true;
            PrintCrystalReport(id, result["result"][0].BranchId, result["result"][0].HospitalId);
          } else {
            if (RequestOPT.value.RequestIds != null && RequestOPT.value.RequestIds.length) {
              await UpdateIsConvertedRequest();
            }
            SaveLoader.value = false
            popup.value.successpop = true;
            PrintCrystalReport(id, result["result"][0].BranchId, result["result"][0].HospitalId);

          }
        }
        // }
      } else {
        SaveLoader.value = false
        toast.add({
          severity: "warn",
          summary: "Please Add the Item",
          detail: "",
          life: 3000,
        });
      }
    })

    async function UpdateIsConvertedRequest() {
      debugger;
      try {
        let result = await commonService.UpdateIsConvertedRequest(RequestOPT.value.RequestIds);
        console.log(result["ErrorInfo"].ErrorCode);
      } catch (error) {
        console.error("Error updating converted request:", error);
      }
    }

    const IsSubmitDraft = handleSubmit(async (values) => {
      debugger;
      loading.value = true
      console.log(requestData.value);
      if (items.value.length > 0) {
        Object.keys(requestData.value).forEach((key) => {
          if (requestData.value[key])
            requestForm.value[key] = requestData.value[key];
        });
        Object.keys(requestForm.value).forEach((key) => {
          if (storeForm.value[key])
            requestForm.value[key] = storeForm.value[key];
        });
        console.log(requestForm.value);

        requestForm.value.CreatedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        requestForm.value.ModifiedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        requestForm.value.BranchId = Number(QueryStringValue.value.BranchId ?? 0);
        requestForm.value.HospitalId = HospitalId;
        requestForm.value.ModifiedBy = UserId;
        requestForm.value.CreatedBy = UserId;

        // requestForm.value.Remarks.length != 0 ? requestForm.value.Remarks = `"${requestForm.value.Remarks}"` : requestForm.value.Remarks;
        // requestForm.value.Remarks.length != 0 ? requestForm.value.Remarks = requestForm.value.Remarks : requestForm.value.Remarks;

        requestForm.value.EntityId = Number(QueryStringValue.value.EntityId);
        requestForm.value.DocDate = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        requestForm.value.StoreId = requestForm.value.FromStore;
        requestForm.value.EntityOperationId = Number(QueryStringValue.value.OperationId ?? 0);
        requestForm.value.DeptRoleId = rolesData.DeptRoleMapId;
        requestForm.value.FromStoreBranchId = commonItemProps.value.FromStoreBranchId;
        requestForm.value.FromStoreBrMapId = commonItemProps.value.FromStoreBrMapId;
        requestForm.value.ToStoreBranchId = commonItemProps.value.ToStoreBranchId;
        requestForm.value.ToStoreBrMapId = commonItemProps.value.ToStoreBrMapId;
        requestForm.value.ToStore = commonItemProps.value.tostoreId;
        requestForm.value.StoreBrMapId = commonItemProps.value.StoreBrMapId;
        requestForm.value.Remarkscheck = requestData.value.Remarkscheck == true ? 1 : 0;
        requestForm.value.IsDraft = 1;

        requestForm.value.IsCamp = ObjCamp.value.IsCamp || false;
        requestForm.value.CampId = 0;
        requestForm.value.InstituteName = ObjCamp.value.InstituteName || "";
        requestForm.value.CampName = ObjCamp.value.CampName || "";
        requestForm.value.CampType = ObjCamp.value.CampType || "";
        requestForm.value.CampDate = ObjCamp.value.CampDate || "";
        requestForm.value.ExpectedIP = ObjCamp.value.ExpectedIP || "";
        requestForm.value.ExpectedOP = ObjCamp.value.ExpectedOP || "";

        let id: any = 0;

        if (QueryStringValue.value.Id) {
          requestForm.value.Id = Number(QueryStringValue.value.Id);
        }

        debugger;
        for (let i = 0; i < dupitems.value.length; i++) {
          let obj = {};
          (obj["ItemId"] = dupitems.value[i]["ItemId"]),
            (obj["Qty"] = dupitems.value[i]["ItemQuantity"]),
            (obj["RefId"] = id),
            (obj["PackSizeId"] = dupitems.value[i]["PackSizeId"]),
            (obj["HSNId"] = dupitems.value[i]["HSNId"]),
            // (obj["TaxId"] = 1),
            (obj["UnitRate"] = dupitems.value[i]["UnitRate"]),
            (obj["Rate"] = dupitems.value[i]["Rate"]),
            (obj["CreatedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
            (obj["ModifiedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
            (obj["CreatedBy"] = UserId),
            (obj["ModifiedBy"] = UserId),
            (obj["Id"] = dupitems.value[i]["StockDetailsId"]),
            (obj["AutoRequestId"] = dupitems.value[i]?.["AutoRequestId"] || 0);

          (obj["Brand"] =
            dupitems.value[i]["Brand"] == null ? 0 : dupitems.value[i]["Brand"]),
            (obj["ModelNumber"] =
              dupitems.value[i]["ModelNumber"] == null
                ? 0
                : dupitems.value[i]["ModelNumber"]),
            (obj["Size"] =
              dupitems.value[i]["Size"] == null ? 0 : dupitems.value[i]["Size"]);
          (obj["FromApproval"] = Number(QueryStringValue.value.IsApproval) || 0);
          (obj["UOM"] = dupitems.value[i]["UOM"])
          arr[i] = obj;
        }

        requestForm.value.StockWODetailList = arr

        let result = await commonService.createStockWODraft(requestForm.value);
        id = result["result"][0].Id
        requestForm.value.Id = id
        for (let i = 0; i < requestForm.value.StockWODetailList.length; i++) {
          const ResultList = result["result"][0]

          // items.value[items.value.length - 1].Id = ResultList.StockWODetailList[0]['Id'];
          // items.value[items.value.length - 1].StockDetailsId = ResultList.StockWODetailList[0]['Id'];

          // items.value[i].Id = ResultList.StockWODetailList[i]['Id'];
          // items.value[i].StockDetailsId = ResultList.StockWODetailList[i]['Id'];
          const existsInItems = items.value.some(item => item.ID === ResultList.StockWODetailList[i]['Id'])
          if (!existsInItems) {
            items.value[items.value.length - 1].Id = ResultList.StockWODetailList[0]['Id'];
            items.value[items.value.length - 1].StockDetailsId = ResultList.StockWODetailList[0]['Id'];
          }

        }
        loading.value = false
      } else {
        toast.add({
          severity: "warn",
          summary: "Please Add the Item",
          detail: "",
          life: 3000,
        });
      }
    })

    const AddItems = async (value) => {
      debugger;

      console.log(value);
      dupitems.value = []

      items.value = await value;
      const lastIndex = Number(items.value.length - 1);
      dupitems.value.push(items.value[lastIndex])

      // Validate required fields before submitting
      const lastItem = items.value[lastIndex];

      // Validate Name (required)
      if (!lastItem.Itemname1) {
        toast.add({
          severity: "warn",
          summary: "Validation Error",
          detail: "Item Name is required.",
          life: 3000,
        });
        return;
      }

      // Validate Quantity (required)
      if (lastItem.ItemQuantity === undefined || lastItem.ItemQuantity <= 0 || isNaN(lastItem.ItemQuantity)) {
        toast.add({
          severity: "warn",
          summary: "Validation Error",
          detail: "Please enter a valid quantity for the item.",
          life: 3000,
        });
        return;
      }

      // Validate UOM (required)
      if (!lastItem.UOM) {
        toast.add({
          severity: "warn",
          summary: "Validation Error",
          detail: "UOM is required.",
          life: 3000,
        });
        return;
      }

      // If all validations pass and we're in draft mode, submit the draft
      if (Number(QueryStringValue.value.IsDraft) == 1) {
        await IsSubmitDraft();
      }
    };

    watch(items, (newItems, oldItems) => {
      debugger;
      if (Number(QueryStringValue.value.IsApproval) == 1) {
        Requestcalculation();
      }
    }, { deep: true });

    const Requestcalculation = () => {
      debugger;
      RequestCalcDetailsClear()
      for (let i = 0; i < items.value.length; i++) {
        items.value[i]["Rate"] = Number(items.value[i]["ItemQuantity"] * items.value[i]["UnitRate"]).toFixed(2);
        RequestCalcDetails.value.GrossAmount += items.value[i]["Rate"];
      }
      RequestSubcalculation()
    };

    const RequestSubcalculation = () => {
      debugger;
      RequestCalcDetails.value.ItemCount = items.value.length;
      RequestCalcDetails.value.TotalAmount = Number((Number(RequestCalcDetails.value.GrossAmount)).toFixed(2));
      approvaldetails.value.ApprovalPrice = RequestCalcDetails.value.TotalAmount;
    }

    function RequestCalcDetailsClear() {
      debugger;
      RequestCalcDetails.value.GrossAmount = 0.00;
      RequestCalcDetails.value.ItemCount = 0;
      RequestCalcDetails.value.TotalAmount = 0.00;
    }

    //Edit
    async function IsEdit() {
      debugger;
      let result = await commonService.GetByStockWOTransId(QueryStringValue.value.Id);
      debugger
      console.log(result);
      result = result["result"];

      items.value = result;
      diffArray = result;
      items.value.sort((a, b) => {
        return a.Itemname1.localeCompare(b.Itemname1);
      });

      Object.keys(storeForm.value).forEach((key) => {
        if (result[0][key]) storeForm.value[key] = result[0][key];
      });
      Object.keys(requestForm.value).forEach((key) => {
        if (result[0][key]) requestForm.value[key] = result[0][key];
      });

      Object.keys(requestData.value).forEach((key) => {
        if (result[0][key]) requestData.value[key] = result[0][key];
      });


      // if (IsApproval.value == 1) {
      commonItemProps.value.storeId = result[0].FromStore;
      commonItemProps.value.tostoreId = result[0].ToStore;
      //}
      debugger
      requestForm.value.Status = result[0].Status
      requestForm.value.ClosedReason = result[0].ClosedReason
      requestForm.value.CancelReason = result[0].CancelReason
      approvaldetails.value.ApprovalCode = result[0].DocNo;
      approvaldetails.value.ApprovalDate = result[0].DocDateHR;
      approvaldetails.value.CreatedAt = result[0].CreatedAt;
      commonItemProps.value.FromStoreBrMapId = result[0].FromStoreBrMapId;
      commonItemProps.value.ToStoreBrMapId = result[0].ToStoreBrMapId;
      commonItemProps.value.StoreBrMapId = result[0].StoreBrMapId;

      commonItemProps.value.FromStoreBranchId = result[0].FromStoreBranchId;
      commonItemProps.value.ToStoreBranchId = result[0].ToStoreBranchId;


      if (result[0].IsCamp) {
        ObjCamp.value.IsCamp = result[0].IsCamp
        ObjCamp.value.CampId = result[0].CampId
        ObjCamp.value.InstituteName = result[0].InstituteName
        ObjCamp.value.CampName = result[0].CampName
        ObjCamp.value.SelectedCampName = result[0].CampName + " - " + moment(result[0].CampDate, "DD-MM-YYYY").format("DD/MM/YYYY");
        ObjCamp.value.CampType = result[0].CampType
        ObjCamp.value.CampDate = moment(result[0].CampDate, "DD-MM-YYYY").format("YYYY-MM-DD");

        ObjCamp.value.FormattedCampDate = moment(result[0].CampDate, "DD-MM-YYYY").format("DD/MM/YYYY");
        ObjCamp.value.ExpectedIP = result[0].ExpectedIP
        ObjCamp.value.ExpectedOP = result[0].ExpectedOP
        ObjCamp.value.CampDetailCard = true;
      }

      requestData.value.Remarkscheck = result[0].Remarkscheck ? true : false
      const FileUploadresult = await StockWOFileUploadServices.getStockWOFileById(
        QueryStringValue.value.Id
      );
      if (FileUploadresult['result'].length > 0) {
        for (let i = 0; i < FileUploadresult['result'].length; i++) {
          let Fileobj = {};
          (Fileobj["url"] = FileUploadresult['result'][i].FileName.split('/FileUpload/')[1]),
            (Fileobj["fileName"] = FileUploadresult['result'][i].FileName.split('/').pop()),
            (Fileobj["fileType"] = Fileobj["url"].split('/')[0]),
            (Fileobj["fullPath"] = FileUploadresult['result'][i].FileName),
            (Fileobj["Id"] = FileUploadresult['result'][i].Id),
            uploadedTableList.value.push(Fileobj)
        }
      }

      if (result[0].IsApproved == 1 && result[0].IsDraft == 1) {
        IsApprovedValue.value = true
      }
      else if (result[0].IsApproved == 0 && result[0].IsDraft == 0) {
        IsApprovedValue.value = true
      }
      else if (result[0].IsApproved == 1 && result[0].IsDraft == 0) {
        IsApprovedValue.value = false
      }
      else {
        IsApprovedValue.value = false
      }
    }

    //ReOrder Level Table
    async function LoadReOrderLevel() {
      debugger;

      let result = await commonService.GetReOrderLevelList(QueryStringValue.value.StoreId, HospitalId, BranchId);
      console.log(result);
      result = result["result"];

      ReOrderData.value = result;
    }

    //Delete ReOrder level Items
    async function IsReOrderDelete(data) {
      debugger;
      let msg = null;

      if (msg == null) {
        ReOrderData.value = ReOrderData.value.filter(
          (item) => item["ItemId"] !== data.ItemId
        );
      }
      console.log(ReOrderData.value);
    }

    function AddSingleConfirmation(val) {
      debugger;
      confirmval.value = val;
      if (ReOrderData.value == "") {
        warningmsgcontent.value.warningcontent = "There is no Items.";
        wariningPopup.value = true;
      } else if (selectedProduct.value == "" || selectedProduct.value == null) {
        warningmsgcontent.value.warningcontent = "Please Select the Items.";
        wariningPopup.value = true;
      } else {
        msgcontent.value.contentvalue =
          "Do you want to add selected items to request ?";
        AddItemmodel.value = true;
      }
    }

    function AddAllConfirmation(val) {
      debugger;
      confirmval.value = val;
      if (ReOrderData.value == "") {
        warningmsgcontent.value.warningcontent = "There is no Items.";
        wariningPopup.value = true;
      } else {
        msgcontent.value.contentvalue =
          "Do you want to add all items to request ?";
        AddItemmodel.value = true;
      }
    }

    function ClosewariningPopup() {
      debugger;
      wariningPopup.value = false;
    }

    function CopyReorderData(selectValue) {
      debugger;

      let dataArray: any = [];
      dataArray = JSON.parse(JSON.stringify(items.value));
      let selectedArray: any = [];
      let checkArray =
        selectValue == "All" ? ReOrderData.value : selectedProduct.value;
      selectedArray = JSON.parse(JSON.stringify(checkArray));
      dataArray.map((item: any) => {
        const item2 = selectedArray.find(
          (data: any) => data.ItemId == item.ItemId
        );
        if (item2) {
          item.ItemQuantity =
            parseInt(item.ItemQuantity) + parseInt(item2.ItemQuantity);
        }
      });

      console.log(items.value);

      let arr1: any = [];

      arr1 = selectedArray.filter(
        (value) => !dataArray.some((i1) => i1.ItemId == value.ItemId)
      );

      for (let i = 0; i < arr1.length; i++) {
        dataArray.push(arr1[i]);
      }
      items.value = dataArray;
      dataItems.value = items.value;
      selectedProduct.value = null;
      ReOrderData.value = ReOrderData.value.filter(
        (value) => !selectedArray.some((i1) => i1.ItemId == value.ItemId)
      );
      AddItemmodel.value = false;
      ItemTab.value = "show";
    }

    function closetrigger() {
      // router.push({
      //   name: "StoreTabDetails",
      //   query: {
      //     status: status,
      //     Id: StoreId,
      //     Type: Type,
      //   },
      // });
      setupHistoryManagement(router, 2);

    }

    function deleteclosetrigger() {
      debugger;
    }

    const ParameterValues = ref({ Id: 0, BranchId: 0, HospitalId: 0 });
    const PrintType = ref({ Type: "S", FormId: 9, ModuleId: 3 });

    function PrintCrystalReport(Id, BranchId, HospitalId) {
      debugger;

      ParameterValues.value.Id = Id;
      ParameterValues.value.BranchId = BranchId;
      ParameterValues.value.HospitalId = HospitalId;


      // Make sure popup doesn't show
      CrystalReportPopup.value = true;
    }

    //Load RequestId(Auto Request Concept for Main Store)
    async function LoadRequestID() {
      debugger;
      try {
        const result = await commonService.GetAutoRequestIds(QueryStringValue.value.StoreId, 1, Number(QueryStringValue.value.BranchId));

        if (result["result"].length > 0) {
          RequestOPT.value.RequestOption = result["result"].map((item) => {
            item.name = item.DocNo + ' / ' + item.DocDateHR;
            item.value = item.Id;
            return item;
          });
        }
        console.log(result);
      } catch (error) {
        console.log(error);
      }
    }

    //Load Frequest RequestId Concept
    async function LoadFrequestRequestID() {
      debugger;
      try {
        const result = await commonService.GetAutoRequestIds(QueryStringValue.value.StoreId, 2, Number(QueryStringValue.value.BranchId));
        if (result["result"].length > 0) {
          RequestOPT.value.FRequestOption = result["result"].map((item) => {
            item.name = item.DocNo + ' / ' + item.DocDateHR;
            item.value = item.Id;
            return item;
          });
        }
        console.log(result);
      } catch (error) {
        console.log(error);
      }
    }

    async function LoadIndentID() {
      debugger;
      try {
        const result = await commonService.GetAutoRequestIds(QueryStringValue.value.StoreId, 3, Number(QueryStringValue.value.BranchId));
        if (result["result"].length > 0) {
          RequestOPT.value.FIndentOption = result["result"].map((item) => {
            item.name = item.DocNo + '/' + item.TemplateName;
            item.value = item.Id;
            return item;
          });
        }
        console.log(result);
      } catch (error) {
        console.log(error);
      }
    }

    //Auto Request Concept Request Id On Change
    async function RequestIDOnChange(requestId) {
      debugger;
      if (requestId) {

        items.value = items.value.filter(
          (item) =>
            requestId?.includes(item?.AutoRequestId) ||
            (item?.AutoRequestId || 0) == 0
        );
        let nonExistingValues
        if (SavingArray.value) {
          nonExistingValues = requestId?.filter(
            (item) => !SavingArray.value.includes(item)
          );
        }
        else {
          nonExistingValues = requestId
        }

        RequestId = nonExistingValues?.toString();
        SavingArray.value = requestId;
        console.log(RequestId);
        if (RequestId && RequestId != "") {
          const result = await commonService.GetAutoRequestItemByRequestId(
            RequestId
          );
          if (result["result"].length > 0) {
            let arr = result["result"].map((item) => {
              item.StockDetailsId = 0;
              let matchArr = items.value.filter(
                (item1) =>
                  item1.ItemId == item.ItemId &&
                  item1.ModelNumber == item.ModelNumber &&
                  item1.Brand == item.Brand &&
                  item1.Size == item.Size
              );
              if (matchArr.length > 0) {
                item.ItemQuantity =
                  Number(item.ItemQuantity) + Number(matchArr[0].ItemQuantity);
                item.StockDetailsId = Number(matchArr[0].StockDetailsId);
                items.value = items.value.filter(
                  (item1) =>
                    !matchArr.some(
                      (item) =>
                        item1.ItemId === item.ItemId &&
                        item1.ModelNumber === item.ModelNumber &&
                        item1.Brand === item.Brand &&
                        item1.Size === item.Size
                    )
                );
              }
              (item.AutoRequestId = item.Id), (item.Availabe = item.StockInHand);
              return item;
            });
            items.value = [...items.value, ...arr];
            const itemMap = new Map();
            items.value.map(item => {
              const key = `${item.ItemId}-${item.ModelNumber}-${item.Brand}-${item.Size}`;
              if (itemMap.has(key)) {
                itemMap.get(key).ItemQuantity += item.ItemQuantity;
              }
              else {
                itemMap.set(key, { ...item });
              }
            });
            items.value = Array.from(itemMap.values());
            items.value.sort((a, b) => {
              return a.Itemname1.localeCompare(b.Itemname1);
            });
          }
        }
        else {
          items.value.length = 0;
        }
      }
    }

    //Frequest Request Id Onchange
    async function FreqRequestIDOnChange(requestId) {
      debugger;
      if (requestId) {
        items.value = items.value.filter(
          (item) =>
            requestId?.includes(item?.FreqRequestId) ||
            (item?.FreqRequestId || 0) == 0
        );

        // let nonExistingValues = requestId?.filter(
        //   (item) => !FSavingArray.value.includes(item)
        // );
        let nonExistingValues
        if (FSavingArray.value) {
          nonExistingValues = requestId?.filter(
            (item) => !FSavingArray.value.includes(item)
          );
        }
        else {
          nonExistingValues = requestId
        }

        FRequestId = nonExistingValues?.toString();
        FSavingArray.value = requestId;
        console.log(FRequestId);
        items.value.sort((a, b) => {
          return a.Itemname1.localeCompare(b.Itemname1);
        });
        if (FRequestId && FRequestId != "") {
          const result = await commonService.GetFreqRequestItemByRequestId(
            FRequestId
          );

          if (result["result"].length > 0) {
            let arr = result["result"].map((item) => {
              item.StockDetailsId = 0;
              let matchArr = items.value.filter(
                (item1) =>
                  item1.ItemId == item.ItemId &&
                  item1.ModelNumber == item.ModelNumber &&
                  item1.Brand == item.Brand &&
                  item1.Size == item.Size
              );
              if (matchArr.length > 0) {
                item.ItemQuantity =
                  Number(item.ItemQuantity) + Number(matchArr[0].ItemQuantity);
                item.StockDetailsId = Number(matchArr[0].StockDetailsId);
                item.AutoRequestId = Number(matchArr[0].AutoRequestId);

                items.value = items.value.filter(
                  (item1) =>
                    !matchArr.some(
                      (item) =>
                        item1.ItemId === item.ItemId &&
                        item1.ModelNumber === item.ModelNumber &&
                        item1.Brand === item.Brand &&
                        item1.Size === item.Size
                    )
                );
              }
              (item.FreqRequestId = item.Id), (item.Availabe = item.StockInHand);
              return item;
            });
            items.value = [...items.value, ...arr];
            const itemMap = new Map();
            items.value.map(item => {
              const key = `${item.ItemId}-${item.ModelNumber}-${item.Brand}-${item.Size}`;
              if (itemMap.has(key)) {
                itemMap.get(key).ItemQuantity += item.ItemQuantity;
              }
              else {
                itemMap.set(key, { ...item });
              }
            });
            items.value = Array.from(itemMap.values());
            items.value.sort((a, b) => {
              return a.Itemname1.localeCompare(b.Itemname1);
            });
          }
        }
        else {
          items.value.length = 0;
        }
      }
    }

    async function IndentIDOnChange(requestId) {
      debugger;
      if (requestId) {
        console.log(requestId);
        if (requestId && requestId != "") {
          items.value = items.value.filter(
            (item) =>
              requestId?.includes(item?.AutoRequestId) ||
              (item?.AutoRequestId || 0) == 0
          );
          items.value.sort((a, b) => {
            return a.Itemname1.localeCompare(b.Itemname1);
          });

          let nonExistingValues;
          if (SavingArray.value) {
            nonExistingValues = requestId?.filter(
              (item) => !SavingArray.value.includes(item)
            );
          }
          else {
            nonExistingValues = requestId;
          }

          requestId = nonExistingValues?.toString();
          SavingArray.value = requestId;
          const result = await IndentTemplateService.GetAutoRequestItemByIndentId(
            requestId
          );

          if (result["result"].length > 0) {
            let arr = result["result"].map((item) => {
              item.StockDetailsId = 0;
              let matchArr = items.value.filter(
                (item1) =>
                  item1.ItemId == item.ItemId &&
                  item1.ModelNumber == item.ModelNumber &&
                  item1.Brand == item.Brand &&
                  item1.Size == item.Size
              );
              if (matchArr.length > 0) {
                item.ItemQuantity =
                  Number(item.ItemQuantity) + Number(matchArr[0].ItemQuantity);
                item.StockDetailsId = Number(matchArr[0].StockDetailsId);
                items.value = items.value.filter(
                  (item1) =>
                    !matchArr.some(
                      (item) =>
                        item1.ItemId === item.ItemId &&
                        item1.ModelNumber === item.ModelNumber &&
                        item1.Brand === item.Brand &&
                        item1.Size === item.Size
                    )
                );
              }
              (item.AutoRequestId = item.Id), (item.Availabe = item.StockInHand);
              return item;
            });
            items.value = [...items.value, ...arr];
            const itemMap = new Map();
            items.value.map(item => {
              const key = `${item.ItemId}-${item.ModelNumber}-${item.Brand}-${item.Size}`;
              if (itemMap.has(key)) {
                itemMap.get(key).ItemQuantity += item.ItemQuantity;
              }
              else {
                itemMap.set(key, { ...item });
              }
            });
            items.value = Array.from(itemMap.values());
          }
        }
        else {
          items.value.length = 0;
        }
      }
    }

    async function LoadCamp() {
      debugger;
      try {

        const SiteId = Number(QueryStringValue.value.SiteId) || 0;

        const result = await CampService.GetCampData(SiteId, HospitalId, QueryStringValue.value.BranchId ?? 0, QueryStringValue.value.Id);

        ObjCamp.value.CampOption = result["result"].map((item) => {
          item.name = item.CampName + " - " + item.CampDate;
          item.value = item.CampName + " - " + item.CampDate;
          return item;
        });
      } catch (error) {
        console.log(error);
      }
    }

    function CampOnChange() {
      debugger;
      if (ObjCamp.value.SelectedCampName) {
        let CampData = ObjCamp.value.CampOption.find((x) => x.name == ObjCamp.value.SelectedCampName);

        ObjCamp.value.InstituteName = CampData.InstituteName;
        ObjCamp.value.CampName = CampData.CampName;
        ObjCamp.value.CampType = CampData.CampType;

        ObjCamp.value.CampDate =
          moment(
            CampData.CampDate,
            "DD-MM-YYYY"
          ).format("YYYY-MM-DD");

        ObjCamp.value.FormattedCampDate = CampData.CampDate;

        ObjCamp.value.ExpectedIP = CampData.ExpectedIP;
        ObjCamp.value.ExpectedOP = CampData.ExpectedOP;

        ObjCamp.value.CampDetailCard = true;
      }
    }

    let isForm = ref({
      EntityOperationId: 0,
      Id: 0,
      EntityApprovalMapID: 0,
      EntityTransactionId: 0,
      ApproverID: UserId,
      DepRoleID: rolesData.DeptRoleMapId,
      IsApproved: 0,
      ApprovedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      Remarks: "",
      EntityId: 0
    });

    async function Approve(Values) {
      debugger;
      try {

        let rowToAssign = null;

        for (let i = 0; i < ApprovalListchange.value.length; i++) {
          if (ApprovalListchange.value[i]["IsApproved"] === 0) {
            rowToAssign = ApprovalListchange.value[i];
            break; // Exit the loop once the first matching row is found
          }
        }

        if (rowToAssign) {

          isForm.value.EntityId = rowToAssign["EntityId"];
          isForm.value.EntityOperationId = rowToAssign["EntityOperationId"];
          isForm.value.Id = rowToAssign["ID"];
          isForm.value.EntityTransactionId = rowToAssign["EntityTransactionId"];

          isForm.value.IsApproved = Values.Approvalstatus;
          isForm.value.Remarks = Values.Remarks;
        }

        let response;
        if (isForm.value.IsApproved == 1) {

          response = await PoApprovalService.POApproval(isForm.value);
          if (response["ErrorInfo"].ErrorCode == null) {
            if (response["result"] == 1 || response["result"] == 2) {
              // IsSubmit();
              UpdateApprovalStatus(response["result"]);
            }
            SuccessfullPopUp.value.accept = true;
          } else {
            alert("Somthing went wrong");
          }
        } else if (isForm.value.IsApproved == 3) {
          response = await PoApprovalService.POReject(isForm.value);
          if (response["ErrorInfo"].ErrorCode == null) {
            UpdateApprovalStatus(isForm.value.IsApproved);
            SuccessfullPopUp.value.decline = true;
          } else {
            alert("Somthing went wrong");
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
    //Get whether the Approve is needed or already approved
    async function getApprovaldata() {
      debugger;
      try {
        let response = await PoApprovalService.GetPOApprovalList(
          QueryStringValue.value.Id,
          HospitalId,
          QueryStringValue.value.BranchId ?? 0,
          QueryStringValue.value.EntityId ?? 0,
        );
        ApprovalList.value = response["result"];
        ApprovalListchange.value = response["result"].filter(
          (item) => item.DepRoleID == DeptRoleMapId
        );
        console.log(response);
      } catch (error) {
        console.log(error);
      }
    }

    async function UpdateApprovalStatus(Status) {
      debugger;
      try {
        const response = await commonService.UpdateApprovalStatus(
          QueryStringValue.value.Id,
          Status
        );

        let message = response["ErrorInfo"].ErrorCode;

        if (message == null) {

          if (Status == 1 || Status == 2) {
            await IsSubmit();
            IsEdit();
          }
        }
      } catch (error) {
        console.log(error);
      }
    }

    const isVisible = ref(false);

    const handleScroll = () => {
      isVisible.value = window.scrollY > 300; // Show button after scrolling 300px
    };

    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    };
    const handleChangedocument = async (event: Event) => {
      debugger;
      debugger;
      let result;
      let files: any = ''
      const input = event.target as HTMLInputElement;
      files = input['files'];
      console.log(files);
      if (files && files.length > 0) {
        debugger;
        for (let i = 0; i < files.length; i++) {
          let form = new FormData();
          console.log(files[i]);
          form.append("file", files[i]);
          console.log(form);
          result = await common.uploadquotation(form, 'TransactionFiles');
          console.log('Uploaded :', result);
          let ResponseValue = result;
          ResponseValue['Id'] = 0
          fullPath.value = result.uploadPath
          uploadedTableList.value.push(ResponseValue)
        }
      }
      debugger
      console.log(uploadedTableList.value)
    };
    function fileviewer(data) {
      debugger
      const newTabUrl = data;
      window.open(newTabUrl, '_blank');
    }
    const fileuploadDelete = async (data) => {
      DeletedFileUpload.push(data.Id)
      uploadedTableList.value = uploadedTableList.value.filter((item) => item.fileName != data.fileName)
    }
    onMounted(() => {
      window.addEventListener('scroll', handleScroll);
    });

    onUnmounted(() => {
      window.removeEventListener('scroll', handleScroll);
    });

    function ItemQtyOnChange(data) {
      debugger
      if (isNaN(data.ItemQuantity) || Number(data.ItemQuantity) <= 0) {
        toast.add({
          severity: "warn",
          summary: "Invalid Input",
          detail: "Please enter a valid number.",
          life: 3000,
        });
        data.ItemQuantity = "";
        return;
      }
    }

    const CrystalReportPopup1 = ref(false);
    const ParameterValues1 = ref({
      Id: 0,
      BranchId: 0,
      HospitalId: 0,
    });

    const PrintType1 = ref({
      Type: "T",
      FormId: 9,
      HeaderTitle: "OutBound Request",
      ModuleId: 3,
    });

    function Print(ObjData) {
      debugger;
      CrystalReportPopup1.value = true;
      ParameterValues1.value.Id = QueryStringValue.value.Id;
      ParameterValues1.value.BranchId = commonItemProps.value.FromStoreBranchId;
      ParameterValues1.value.HospitalId = HospitalId;
    }

    const hidepopup = () => {
      CrystalReportPopup1.value = false;
    };


    return {
      ItemQtyOnChange,
      SaveLoader,
      isVisible,
      scrollToTop,
      IsSubmitChk,
      getApprovaldata,
      Approve,
      SuccessfullPopUp,
      approvaldetails,
      ApprovalListchange,
      ApprovalList,
      TblIndex,
      RequestIDOnChange,
      IndentIDOnChange,
      RequestOPT,
      showitemfield,
      items,
      headers,
      loading,
      storeForm,
      requestForm,
      IsSubmit,
      AddItems,
      showFields,
      IsItemEdit,
      dataItems,
      IsItemDelete,
      display,
      displayClass,
      fieldData,
      popup,
      requestData,
      closetrigger,

      LoadReOrderLevel,
      ReOrderData,
      ReOrderheaders,
      IsReOrderDelete,
      selectedProduct,
      CopyReorderData,
      AddSingleConfirmation,
      AddAllConfirmation,
      AddItemmodel,
      confirmval,
      deleteclosetrigger,
      wariningPopup,
      ClosewariningPopup,
      msgcontent,
      warningmsgcontent,
      ItemTab,
      StoreDetailsData,
      commonItemProps,
      storeUpdate,
      CrystalReportPopup,
      ParameterValues,
      PrintType,
      FreqRequestIDOnChange,
      RequestCalcDetails,
      QueryStringValue,
      IsApprovedValue,
      handleChangedocument,
      uploadedTableList,
      fileviewer,
      fileuploadDelete,
      ObjCamp,
      CampOnChange,
      label,
      ItemDeleteConfirm,
      CrystalReportPopup1,
      ParameterValues1,
      PrintType1,
      hidepopup,
      Print
    };
  },
});
</script>
<style lang="scss">
/* .white-blue-border */

.transactiontabs .p-tabview .p-tabview-panels {
  margin-top: 0 !important;
}
</style>
<style lang="scss" scoped>
.campdetailscard {
  border: 1px solid #e1e1e1;
  padding: 15px;
  border-radius: 5px;
  margin-top: 15px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
}
</style>
